/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneCreate
 */
export interface PhoneCreate {
    /**
     * 
     * @type {string}
     * @memberof PhoneCreate
     */
    vehicleDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneCreate
     */
    androidId: string;
    /**
     * 
     * @type {Date}
     * @memberof PhoneCreate
     */
    appLastUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PhoneCreate
     */
    currentAppVersion: string;
}

/**
 * Check if a given object implements the PhoneCreate interface.
 */
export function instanceOfPhoneCreate(value: object): value is PhoneCreate {
    if (!('androidId' in value) || value['androidId'] === undefined) return false;
    if (!('appLastUpdatedAt' in value) || value['appLastUpdatedAt'] === undefined) return false;
    if (!('currentAppVersion' in value) || value['currentAppVersion'] === undefined) return false;
    return true;
}

export function PhoneCreateFromJSON(json: any): PhoneCreate {
    return PhoneCreateFromJSONTyped(json, false);
}

export function PhoneCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleDeviceId': json['vehicleDeviceId'] == null ? undefined : json['vehicleDeviceId'],
        'androidId': json['androidId'],
        'appLastUpdatedAt': (new Date(json['appLastUpdatedAt'])),
        'currentAppVersion': json['currentAppVersion'],
    };
}

export function PhoneCreateToJSON(json: any): PhoneCreate {
    return PhoneCreateToJSONTyped(json, false);
}

export function PhoneCreateToJSONTyped(value?: PhoneCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleDeviceId': value['vehicleDeviceId'],
        'androidId': value['androidId'],
        'appLastUpdatedAt': value['appLastUpdatedAt'].toISOString(),
        'currentAppVersion': value['currentAppVersion'],
    };
}

